import {Component, HostListener, inject, OnInit} from '@angular/core';
import {Event, RouterEvent, Router, NavigationEnd} from '@angular/router';
import queryString from 'query-string';
import {filter} from 'rxjs';
import {MenuItem} from './sidebar.metadata';
import {MenuItem as MenuItem1} from 'primeng/api';
import {cloneDeep, compact, intersection, isEqual, pullAt} from 'lodash';
declare var $: any;
import {AuthService} from 'src/app/services/auth/auth.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
})

export class SidebarComponent implements OnInit {

  constructor(
    private router: Router,
    private authService: AuthService,
  ) {
    this.screenWidth = window.innerWidth;
    router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((e: any) => {
      const pathname = window.location.pathname;
      if (this.menuItems.length > 0) {
        this.menuItems = cloneDeep(this.menuItems);
        this.fnCutArray(e.url, cloneDeep(this.menuItems));
        localStorage.setItem('menuItems', JSON.stringify(this.menuItems));
      } else {
        this.getListMenuByUserId(pathname);
      }
    });
  }


  menulist1: any[] = [];
  menulist2: any[] = [];
  menuItems: MenuItem[] = [];
  screenWidth: number = 0;

  menusss: MenuItem1[] = [];

  @HostListener('window:resize', ['$event'])
  onResize() {
    const pathname = window.location.pathname;
    this.screenWidth = window.innerWidth;
    this.menuItems = cloneDeep(this.menuItems);
    this.fnCutArray(pathname, cloneDeep(this.menuItems));
    localStorage.setItem('menuItems', JSON.stringify(this.menuItems));
  }

  fnCutArray(url: string, menuItems: any) {
    if (navigator.userAgent.indexOf('Mac OS X') != -1) {
      const array = menuItems;
      const pulled = pullAt(array, [0, 1, 2, 3, 4, 5, 6, 7]);
      this.menulist1 = pulled;
      this.menulist2 = array;
      this.parseObjectProperties(this.menulist1, url);
      this.parseObjectProperties(this.menulist2, url);
      this.menulist1 = [...this.menulist1];
      this.menulist2 = [...this.menulist2];
    } else {

      if (this.screenWidth < 576) {
        // this.mediaBreakpoint$.next('xs');
      } else if (this.screenWidth >= 576 && this.screenWidth < 768) {
        // this.mediaBreakpoint$.next('sm');


      } else if (this.screenWidth > 1400 && this.screenWidth <= 1600) {
        const array = menuItems;
        const pulled = pullAt(array, [0, 1, 2, 3, 4, 5, 6, 7, 8]);
        this.menulist1 = pulled;
        this.menulist2 = array;
        this.parseObjectProperties(this.menulist1, url);
        this.parseObjectProperties(this.menulist2, url);
        this.menulist1 = [...this.menulist1];
        this.menulist2 = [...this.menulist2];
      } else if (this.screenWidth > 1280 && this.screenWidth <= 1400) {
        const array = menuItems;
        const pulled = pullAt(array, [0, 1, 2, 3, 4, 5, 6, 7]);
        this.menulist1 = pulled;
        this.menulist2 = array;
        this.parseObjectProperties(this.menulist1, url);
        this.parseObjectProperties(this.menulist2, url);
        this.menulist1 = [...this.menulist1];
        this.menulist2 = [...this.menulist2];
      } else if (this.screenWidth > 1024 && this.screenWidth <= 1280) {
        const array = menuItems;
        const pulled = pullAt(array, [0, 1, 2, 3, 4, 5, 6]);
        this.menulist1 = pulled;
        this.menulist2 = array;
        this.parseObjectProperties(this.menulist1, url);
        this.parseObjectProperties(this.menulist2, url);
        this.menulist1 = [...this.menulist1];
        this.menulist2 = [...this.menulist2];
      } else if (this.screenWidth > 960 && this.screenWidth <= 1024) {
        const array = menuItems;
        const pulled = pullAt(array, [0, 1, 2, 3, 4, 5]);
        this.menulist1 = pulled;
        this.menulist2 = array;
        this.parseObjectProperties(this.menulist1, url);
        this.parseObjectProperties(this.menulist2, url);
        this.menulist1 = [...this.menulist1];
        this.menulist2 = [...this.menulist2];
      } else {
        const array = menuItems;
        this.menulist1 = array;
        this.menulist2 = [];
        this.parseObjectProperties(this.menulist1, url);
        this.menulist1 = [...this.menulist1];
      }
    }


  }

  ngOnInit() {
    this.menusss = [
      {
        label: 'File',
        icon: 'pi pi-fw pi-file',
        items: [
          {
            label: 'New',
            icon: 'pi pi-fw pi-plus',
            items: [
              {
                label: 'Bookmark',
                icon: 'pi pi-fw pi-bookmark'
              },
              {
                label: 'Video',
                icon: 'pi pi-fw pi-video'
              }
            ]
          },
          {
            label: 'Delete',
            icon: 'pi pi-fw pi-trash'
          },
          {
            separator: true
          },
          {
            label: 'Export',
            icon: 'pi pi-fw pi-external-link'
          }
        ]
      },
      {
        label: 'Edit',
        icon: 'pi pi-fw pi-pencil',
        items: [
          {
            label: 'Left',
            icon: 'pi pi-fw pi-align-left'
          },
          {
            label: 'Right',
            icon: 'pi pi-fw pi-align-right'
          },
          {
            label: 'Center',
            icon: 'pi pi-fw pi-align-center'
          },
          {
            label: 'Justify',
            icon: 'pi pi-fw pi-align-justify'
          }
        ]
      },
      {
        label: 'Users',
        icon: 'pi pi-fw pi-user',
        items: [
          {
            label: 'New',
            icon: 'pi pi-fw pi-user-plus'
          },
          {
            label: 'Delete',
            icon: 'pi pi-fw pi-user-minus'
          },
          {
            label: 'Search',
            icon: 'pi pi-fw pi-users',
            items: [
              {
                label: 'Filter',
                icon: 'pi pi-fw pi-filter',
                items: [
                  {
                    label: 'Print',
                    icon: 'pi pi-fw pi-print'
                  }
                ]
              },
              {
                icon: 'pi pi-fw pi-bars',
                label: 'List'
              }
            ]
          }
        ]
      },
      {
        label: 'Events',
        icon: 'pi pi-fw pi-calendar',
        items: [
          {
            label: 'Edit',
            icon: 'pi pi-fw pi-pencil',
            items: [
              {
                label: 'Save',
                icon: 'pi pi-fw pi-calendar-plus'
              },
              {
                label: 'Delete',
                icon: 'pi pi-fw pi-calendar-minus'
              }
            ]
          },
          {
            label: 'Archieve',
            icon: 'pi pi-fw pi-calendar-times',
            items: [
              {
                label: 'Remove',
                icon: 'pi pi-fw pi-calendar-minus'
              }
            ]
          }
        ]
      },
      {
        separator: true
      },
      {
        label: 'Quit',
        icon: 'pi pi-fw pi-power-off'
      }
    ];
    // const pathname  = window.location.pathname ;
    // this.menuItems = menus.filter(menuItem => menuItem);
    //     this.parseObjectProperties(this.menuItems, pathname);
    //     this.menuItems = [...this.menuItems];
  }

  getListMenuByUserId(pathname: string) {
    const queryMeny = queryString.stringify({
      userId: this.authService.getClaims().sub,
      webId: '70e930b0-ffea-43d3-b3a9-0e6b03f2b433'
    });
    // this._apiService.clientMenuGetListByUserId(queryMeny).subscribe(results => {
    //   if (results.status === 'success') {
    //     this.menuItems = results.data.filter((menuItem: MenuItem) => menuItem);
    //     localStorage.setItem('menuItems', JSON.stringify(results.data));
    //     this.fnCutArray(pathname, cloneDeep(this.menuItems));
    //   }
    // });
  }

  parseObjectProperties2(obj: any[], pathname: string) {
    for (const k of obj) {
    }
  }


  parseObjectProperties(obj: any[], pathname: string) {
    for (const k of obj) {
      k.label = k.title;
      if (k.path && k.classs !== 'navigation-header') {
        k.routerLink = k.path;
        k.icon = '';
      }
      if (k.classs === 'nav-item' && k.path === '') {
        const router = this.router.url ? this.router.url.split('/') : [];
        if (router.indexOf(k.menuId) > -1) {
          localStorage.setItem('menuActive', JSON.stringify(k));
          this.router.navigate(['/notfound', k.menuId]);
        }
      }
      k.command = () => {
        if (k.classs === 'nav-item' && k.path === '') {
          localStorage.setItem('menuActive', JSON.stringify(k));
          this.router.navigate(['/notfound', k.menuId]);
        }
      };
      if (k.path && k.classs === 'nav-link') {
        k.routerLink = k.path;
      }
      if (k.submenus && k.submenus.length > 0) {
        k.items = k.submenus.filter((d: any) => d.classs && (d.classs.indexOf('hidden') < 0));
      }
      if (k.routerLink) {
        // active menu con
        if (k.classs === 'navigation-header') {
          if (k.routerLink && pathname.includes(k.routerLink)) {
            k.styleClass = 'parent_active' + ' ' + k.classs;
          } else {
            k.styleClass = 'parent_no_active' + ' ' + k.classs;
          }
        } else {
          const newpathname = pathname ? compact(pathname.split('/')) : [];
          const newrouterLink = k.routerLink ? compact(k.routerLink.split('/')) : [];
          if (newpathname.length <= newrouterLink.length) {
            if (k.routerLink && pathname === k.routerLink) {
              k.styleClass = k.classs + ' active' + ' ' + k.classs;
              k.icon = '';
            } else {
              k.styleClass = k.classs + ' no-active' + ' ' + k.classs;
              k.icon = '';
            }
          } else {
            if (k.routerLink && isEqual(intersection(newpathname, newrouterLink), newrouterLink)) {
              k.styleClass = k.classs + ' active' + ' ' + k.classs;
              k.icon = '';
            } else {
              k.styleClass = k.classs + ' no-active' + ' ' + k.classs;
              k.icon = '';
            }
          }
        }
      } else {
        // active cha
        // if (k.path && pathname && pathname.split('/').indexOf(k.path) > -1 && k.classs === 'navigation-header') {
        //   k.styleClass = 'parent_active' + ' ' + k.classs;
        // } else {
        //   k.styleClass = 'parent_no_active' + ' ' + k.classs;
        // }

        if (k.submenus && k.submenus.length > 0) {
          const items = k.submenus.filter((i: any) => i.path && pathname.includes(i.path));
          if (items.length > 0) {
            k.styleClass = 'parent_active' + ' ' + k.classs;
            k.expanded = true;
          }
        } else {
          if (k.path === '/home') {
            k.routerLink = k.path;
            k.icon = 'uni-icon uni-home-building uni-white-color uni-hover-orange';
            // k.isExternalLink = true;
          }
        }
      }

      if (k.hasOwnProperty('items') && Array.isArray(k.items) && k.items.length > 0) {
        this.parseObjectProperties(k.items, pathname);
      }
    }
  }


}
